import * as model from './model';
import * as actions from './actions';

export const mediaCampaign = {
  ...model,
  ...actions,
};
